import classNames from "classnames";

type StepperProps = {
  steps: number;
  activeStep: number;
  onSelect?: (index: number) => void;
  theme?: "primary" | "secondary";
  disableNext?: boolean;
};

const Stepper = ({ theme = "primary", steps, activeStep, disableNext = true, onSelect }: StepperProps) => {
  const items = Array.from({ length: steps });

  const selectedTheme = {
    primary: {
      backgroundColor: "bg-navy-blue",
    },
    secondary: {
      backgroundColor: "bg-brand-purple",
    },
  }[theme];

  return (
    <div className="flex w-full gap-4" aria-label="Progress steps">
      {items.map((_, index) => {
        const isSelected = index === activeStep;
        const isCompletedStep = index < activeStep;

        return (
          <button
            key={index}
            disabled={!onSelect || (disableNext && index > activeStep)}
            onClick={() => onSelect?.(index)}
            aria-current={isSelected ? "step" : undefined}
            aria-label={`Step ${index + 1} of ${steps}${isSelected ? ", current step" : ""}`}
            className="flex-1 py-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple rounded-full"
          >
            <div
              data-testid={`step-${index + 1}`}
              className={classNames(
                "text-center py-1 transition-colors rounded-full",
                isSelected || isCompletedStep ? selectedTheme?.backgroundColor : "bg-brand-grey"
              )}
            />
          </button>
        );
      })}
    </div>
  );
};

export default Stepper;
